module.exports = __webpack_public_path__ + "static/media/logo.ccf6ed79.jpg";